import { Component, type ReactNode } from "react";
import { reportError } from "../ops/report";

/**
 * A boundary for what only decorates the table: a gift in flight, a reaction bubble, a rank frame.
 * If one of them throws it is simply not drawn, and the table plays on (review 0027 C9); the app's
 * own boundary would have replaced the whole match with an error screen. The error is still reported.
 */
export class Ornament extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override componentDidCatch(error: unknown): void {
    reportError("boundary", error, { stage: "ornament" });
  }

  override render(): ReactNode {
    return this.state.failed ? null : this.props.children;
  }
}
